<template>
  <v-list>
    <template v-if="state==='load'">
      <v-skeleton-loader
        v-for="i in 10"
        :key="'skeleton-meta-topic-id-' + i"
        type="list-item-avatar-two-line"
        light
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <item v-for="topic in topics" :key="'meta-topic-id-' + topic.id"  :item="topic"></item>
    </template>
  </v-list>
</template>

<script>
import Item from './base/Item'
export default {
  name: 'ListOfTopics',
  components: {
    Item
  },
  data () {
    return {
      topics: [],
      state: 'load'
    }
  },
  methods: {
    async getTopic () {
      try {
        this.state = 'load'
        this.topics = (await this.$content.get('study-topics/')).data
        this.state = 'ok'
      } catch {
        this.state = 'error'
      }
    }
  },
  created () {
    this.getTopic()
  }
}
</script>

<style scoped>

</style>
